import { render, staticRenderFns } from "./PatientDocumentListViewer.vue?vue&type=template&id=4a77ac13&scoped=true&"
import script from "./PatientDocumentListViewer.vue?vue&type=script&lang=ts&"
export * from "./PatientDocumentListViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDocumentListViewer.vue?vue&type=style&index=0&id=4a77ac13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77ac13",
  null
  
)

export default component.exports